import React, { Component } from "react";
import {
  Col,
  Row,
  Card,
  CardHeader,
  CardBody,
  ListGroup,
  ListGroupItem,
  CardTitle,
} from "reactstrap";
import { connect } from "react-redux";
import { Tooltip, Collapse } from "antd";
// import { login, logout } from 'store/auth/actions';
import LineChart from "components/charts/LineChart";
import ProgressTable from "components/tables/ProgressTable";
import InfoCards from "./components/InfoCards";
import SubjectWiseProgress from "./components/SubjectWiseProgress";
import ConceptWiseProgress from "./components/ConceptWiseProgress";
import WealthInfo from "./components/WealthInfo";
import FastestPerformance from "./components/FastestPerformance";
import BlockUi from "react-block-ui";
import "react-block-ui/style.css";
import apiurl from "../../apiurl";
import api from "services/api";
import { mcqSubjectNames } from "services/utility";

const axios = require("axios");
const { Panel } = Collapse;
var dateFormat = require("dateformat");

const mapStateToProps = (state) => {
  console.log(state);
  console.log(state.user);
  const user = state.user;

  // return {
  //     name: 'Avinash', // state.auth.user ? state.auth.user.fullName : 'Avinash',
  //     studentId: user.id || 2745794,
  //     // gradeId: user.gradeAlpaId || '5e8c41468103e188b8003c57',
  //     // boardId: user.boardAlpaId || '5e8c428336bf63c0c1f65726',
  //     gradeId: user.gradeAlpaId || '',
  //     boardId: user.boardAlpaId || '',
  //     grade: user.grade_id || 8,
  //     filter: user.filter || "day",
  //     param: user.param || "all",
  //     loggedInUser: state.user,
  // }
  return {
    name: "Avinash", // state.auth.user ? state.auth.user.fullName : 'Avinash',
    studentId: user.id || 2745794,
    gradeId: user.gradeId || "5e8c41468103e188b8003c57",
    boardId: user.boardId || "5e8c428336bf63c0c1f65726",
    boardName: user.board_name || "",
    grade: user.grade_name || 8,
    filter: user.filter || "day",
    param: user.param || "all",
    loggedInUser: state.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    // login: (payload) => {
    //     dispatch(login(payload))
    // },
    // setData: (payload) => {
    //     dispatch(setData(payload))
    // },
    // clearData: () => {
    //     dispatch(clearData())
    // },
    // logout: () => {
    //     dispatch(logout())
    // }
  };
};

class StudentDashboard extends Component {
  state = {
    // name: 'Avinash',
    knowledgeWealth: 0,
    knowledgeCurrency: 0,
    learningCurrency: 0,
    totalQuesAnswered: 0,
    dailyStreak: {
      labels: [],
      learningCurrency: [],
      knowledgeCurrency: [],
    },
    userProgressVsOthers: {
      labels: [],
      other: [],
      user: [],
      // pointIndex:5,
    },
    userProfile: {
      board_name: "",
      email_id: "",
      full_name: "",
      grade_roman: "",
      mobile_no: "",
      school_name: "",
      user_id: "",
    },
    weakPerformance: [],
    subjectWiseProgress: [],
    isLoading: true,
    selectedSubject: null,
    loadSubjectData: false,
    blocking: true,
    subjectWiseloader: false,
    weeklyChartTitle: "Daily",
    toolTiptitle:
      "It denotes the Daily progress of the student in knowledge and learning efficiency.",
    recSubjectName: [],
  };

  componentDidMount() {
    this.getData();
  }

  async getData() {
    try {
      // const { student: result } = await window.$http.get('parent/parentdashboard', {
      const resultData = await axios.get(
        "https://7tfx1ljzua.execute-api.ap-south-1.amazonaws.com/PROD/parent/parentviewpart-1-dev",
        {
          params: {
            studentId: this.props.studentId,
            // gradeId: this.props.gradeId,
            // boardId: this.props.boardId,
            boardName: this.props.boardName,
            grade: this.props.grade,
            filter: this.props.filter,
            param: this.props.param,
          },
        }
      );
      let result = resultData.data.student;

      console.log("RESULT", result);

      let userProfile = {
        board_name: result.userProfile.board_name,
        email_id: result.userProfile.email_id,
        full_name: result.userProfile.full_name,
        grade_roman: result.userProfile.grade_roman,
        mobile_no: result.userProfile.mobile_no,
        school_name: result.userProfile.school_name,
        user_id: result.userProfile.user_id,
      };

      // this.props.login({ schoolName: 'Student Profile' })
      let rps = result.recentlyPlayedCards.map((i) => i);

      this.setState({
        isLoading: false,
        blocking: false,
        // knowledgeWealth: Math.round(result.knowledgeWelth) || 0,
        // knowledgeCurrency: Math.round(result.knowledgeCurrency) || 0,
        // learningCurrency: Math.round(result.learningCurrency) || 0,
        knowledgeWealth: result.knowledgeWelth || 0,
        knowledgeCurrency: result.knowledgeCurrency || 0,
        learningCurrency: result.learningCurrency || 0,
        totalQuesAnswered: result.overallAccuracy || 0,
        userProfile: userProfile,
        dailyStreak: {
          labels: result.dailyStreak && result.dailyStreak.map((i) => i.date),
          learningCurrency:
            result.dailyStreak &&
            result.dailyStreak.map((i) => i.learningCurrency || 0),
          knowledgeCurrency:
            result.dailyStreak &&
            result.dailyStreak.map((i) => i.knowledgeCurrency || 0),
        },
        weakPerformanceComp: result.conceptNeedingImprovement,
        weakPerformance:
          result.conceptNeedingImprovement &&
          result.conceptNeedingImprovement
            .map((p) =>
              p.score.map((s) => ({
                subject: p.subject,
                chapter: s.chapter,
                knowledgeWealth: s.knowledgeWealth,
                avgKnowledgeWealth: s.overallKnowledgeWealth,
              }))
            )
            .flat(),
        subjectWiseProgress: this.getSubjectWiseProgress(
          result.subjectwiseAnalysis
        ),
        filter: this.props.filter,
        recSubjectName: rps,
      });
    } catch (err) {
      console.log(err);
      // window.$utility.showMessage('error', err.message);
    }
  }

  getSubjectWiseProgress = (subjects) => {
    const items = [];
    for (const sub of subjects) {
      const report = sub.report && sub.report.length ? sub.report[0] : null;

      const userWealth = {
        knowledgeCurrency: report && report.knowledgeCurrency,
        learningCurrency: report && report.learningCurrency,
        knowledgeWealth: report && report.knowledgeWelth,
        accuracy: report && report.accuracy,
        avgAccuracy: report && report.otherUserAccuracy,
        avgTime: report && report.avgTimePerQuestion,
        avgTimePerQues: report && report.otherUserAvgTimePerQuestion,
      };

      const bestPerformance =
        sub.bestPerformance &&
        sub.bestPerformance.map((p) => ({
          subject: p.subjectName,
          chapter: p.chapterName,
          knowledgeWealth: p.knowledgeCurrency,
          avgKnowledgeWealth: p.avgKnowledgeCurrency,
        }));

      const fastestPerformance =
        sub.fastPerformance &&
        sub.fastPerformance.map((p) => ({
          subject: p.subjectName,
          chapter: p.chapterName,
          timePerQues: p.avgTimePerQuestion,
          accuracy: p.accuracy,
          quesAnswered: p.totalQuestionsAnswered,
        }));

      items.push({
        name: sub.subjectName,
        subjectId: sub.subjectId,
        labels: ["Complete", "Incomplete"],
        data: [
          Math.round((sub.completedTopic / sub.totalTopic) * 100),
          Math.round(100 - (sub.completedTopic / sub.totalTopic) * 100),
        ],
        total: sub.totalTopic || 0,
        completed: sub.completedTopic || 0,
        userProgressVsOthers: {
          labels: sub.whereUserStand && sub.whereUserStand.map((p) => p.xAxis),
          other:
            sub.whereUserStand &&
            sub.whereUserStand.map((p) => p.overallUserCount),
          user:
            sub.whereUserStand && sub.whereUserStand.map((p) => p.userCount),
        },
        chapterPerformance: sub.completionReport,
        userWealth,
        bestPerformance,
        fastestPerformance,
        pointIndex:
          sub.whereUserStand &&
          sub.whereUserStand.findIndex((p) => p.userCount),
      });
    }
    return items;
  };

  selectSubject = (sub) => {
    this.setState({
      selectedSubject: sub,
      subjectWiseloader: true,
    });
    this.getSubjectData(sub);
  };

  async changeFilterFunc(e) {
    let title;
    if (e === "day") {
      title = "Daily";
    } else if (e === "week") {
      title = "Weekly";
    } else if (e === "month") {
      title = "Monthly";
    }
    this.setState({
      weeklyChartTitle: title,
      toolTiptitle:
        "It denotes the " +
        title +
        " progress of the student in knowledge and learning efficiency.",
    });
    const { student: result } = await window.$http.get(
      apiurl.dev_studentView1Api,
      {
        studentId: this.props.studentId,
        gradeId: this.props.gradeId,
        boardId: this.props.boardId,
        grade: this.props.grade,
        filter: e,
        param: this.props.param,
      }
    );

    this.setState({
      dailyStreak: {
        labels: result.dailyStreak && result.dailyStreak.map((i) => i.date),
        learningCurrency:
          result.dailyStreak &&
          result.dailyStreak.map((i) => i.learningCurrency || 0),
        knowledgeCurrency:
          result.dailyStreak &&
          result.dailyStreak.map((i) => i.knowledgeCurrency || 0),
      },
      filter: e,
    });
  }

  async getSubjectData(sub) {
    // const result = await window.$http.get(apiurl.dev_studentView2Api, {
    try {
      const resultData = await axios.get(
        "https://7tfx1ljzua.execute-api.ap-south-1.amazonaws.com/PROD/parent/parentviewpart-2-dev",
        {
          params: {
            studentId: this.props.studentId,
            gradeId: this.props.gradeId,
            boardId: this.props.boardId,
            boardName: this.props.boardName,
            grade: this.props.grade,
            subjectId: sub.subjectId,
            param: this.props.param,
          },
        }
      );
      console.log(resultData);
      let subjects = resultData.data.student.subjectwiseAnalysis;

      //   let subjects = "";
      console.log(subjects);

      const bestPerformance =
        subjects[0].bestPerformance &&
        subjects[0].bestPerformance.map((p) => ({
          subject: p.subjectName,
          chapter: p.chapterName,
          knowledgeWealth: p.knowledgeCurrency,
          avgKnowledgeWealth: p.avgKnowledgeCurrency,
        }));

      const fastestPerformance =
        subjects[0].fastPerformance &&
        subjects[0].fastPerformance.map((p) => ({
          subject: p.subjectName,
          chapter: p.chapterName,
          timePerQues: p.avgTimePerQuestion,
          accuracy: p.accuracy,
          quesAnswered: p.totalQuestionsAnswered,
        }));

      const chapterPerformance = subjects[0].completionReport;

      const userProgressVsOthers = {
        labels:
          subjects[0].whereUserStand &&
          subjects[0].whereUserStand.map((p) => p.xAxis),
        other:
          subjects[0].whereUserStand &&
          subjects[0].whereUserStand.map((p) => p.overallUserCount),
        user:
          subjects[0].whereUserStand &&
          subjects[0].whereUserStand.map((p) => p.userCount),
        pointIndex:
          subjects[0].whereUserStand &&
          subjects[0].whereUserStand.findIndex((p) => p.userCount),
      };

      const userWealth = {
        knowledgeCurrency:
          subjects[0].report && subjects[0].report[0].knowledgeCurrency,
        learningCurrency:
          subjects[0].report && subjects[0].report[0].learningCurrency,
        knowledgeWealth:
          subjects[0].report && subjects[0].report[0].knowledgeWelth,
        accuracy: subjects[0].report && subjects[0].report[0].accuracy,
        avgAccuracy:
          subjects[0].report && subjects[0].report[0].otherUserAccuracy,
        avgTime: subjects[0].report && subjects[0].report[0].avgTimePerQuestion,
        avgTimePerQues:
          subjects[0].report &&
          subjects[0].report[0].otherUserAvgTimePerQuestion,
        completedChapterCount: subjects[0].completedChapterCount,
        completedTopicCount: subjects[0].completedTopicCount,
      };

      this.setState({
        bestPerformance: bestPerformance,
        fastestPerformance: fastestPerformance,
        chapterPerformance: chapterPerformance,
        userProgressVsOthers: userProgressVsOthers,
        userWealth: userWealth,
        loadSubjectData: true,
        subjectWiseloader: false,
      });
    } catch (err) {
      console.log(err);
    }
  }

  viewSubjectDetail() {
    this.props.history.goBack();
  }

  render() {
    // const role = this.props.loggedInUser.role;
    const role = "student";
    return (
      <div id="CommonPageHolder">
        <div
          id="subject-cards"
          className={`container-fluid animated fadeIn subject-biology`}
        >
          <BlockUi
            className="container-fluid"
            tag="div"
            blocking={this.state.blocking}
            keepInView
          >
            {role === "student" ? (
              <React.Fragment>
                <div className="row no-gutters top-fixed-bar head-bread-crumb-dashboard">
                  {/* <div className="back-nav">
                                      <icon className="icon-back-arrow"></icon>
                                      </div> */}
                  <div className="col bread-crumb px-0">
                    {this.state.userProfile.full_name || ""}
                  </div>
                  <div className="back-nav-btn text-right"></div>
                </div>
              </React.Fragment>
            ) : (
              ""
            )}
            <Row>
              <InfoCards {...this.state} />
            </Row>
            <Row>
              <Col xs="12" sm="12" lg="12">
                <Card>
                  <CardHeader className="dash-card-header">
                    Student Profile
                  </CardHeader>
                  <CardBody className="mb-2">
                    <div className="row student-profile-flex">
                      <div className="student-profile-item-flex">
                        <div className="student-profile-label">
                          Student Id :
                        </div>
                        <div className="student-profile-value">
                          {" "}
                          {this.state.userProfile.user_id}
                        </div>
                      </div>
                      <div className="student-profile-item-flex">
                        <div className="student-profile-label">Name :</div>
                        <div className="student-profile-value">
                          {" "}
                          {this.state.userProfile.full_name || "NA"}
                        </div>
                      </div>
                      <div className="student-profile-item-flex">
                        <div className="student-profile-label">
                          Mobile no. :
                        </div>
                        <div className="student-profile-value">
                          {this.state.userProfile.mobile_no || "NA"}
                        </div>
                      </div>
                      <div className="student-profile-item-flex">
                        <div className="student-profile-label">School :</div>
                        <div className="student-profile-value">
                          {" "}
                          {this.state.userProfile.school_name || "NA"}
                        </div>
                      </div>
                      <div className="student-profile-item-flex">
                        <div className="student-profile-label">Grade :</div>
                        <div className="student-profile-value">
                          {" "}
                          {this.state.userProfile.grade_roman || "NA"}
                        </div>
                      </div>
                      <div className="student-profile-item-flex">
                        <div className="student-profile-label">Email :</div>
                        <div className="student-profile-value">
                          {" "}
                          {this.state.userProfile.email_id || "NA"}
                        </div>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
            <Row>
              <Col xs="12" sm="12" lg="6">
                {/* <LineChart
                            // heading="Weekly Progress"
                            heading={<div>{this.state.weeklyChartTitle + " Progress"}&nbsp;&nbsp;  <Tooltip title= {this.state.toolTiptitle}> <icon className="icon-inform" aria-hidden="true"></icon> </Tooltip> </div>}
                            labels={this.state.dailyStreak.labels}
                            label="Knowledge Currency"
                            label2="Learning Currency"
                            data={this.state.dailyStreak.knowledgeCurrency}
                            color="#ffc107"
                            data2={this.state.dailyStreak.learningCurrency}
                            color2="#c8ced3"
                            height={250}
                            filterValue={this.state.filter}
                            showFilter={true}
                            changeFilter={this.changeFilterFunc.bind(this)}
                        /> */}
                <Card className="card-shadow">
                  <CardHeader className="dash-card-header">
                    Recently Played Card{" "}
                    <Tooltip title="Last 3 activities played on STEPapp will appear here, this can be a topic or chapter end quiz i.e treasure island.">
                      {" "}
                      <icon
                        className="icon-inform text-icon dash-icon-inform"
                        aria-hidden="true"
                      ></icon>{" "}
                    </Tooltip>
                  </CardHeader>
                  <CardBody>
                    {this.state.recSubjectName.map((item, i) => (
                      <Collapse accordion defaultActiveKey={["1"]}>
                        <Panel header={item.subjectName}>
                          <div
                            className={`subject-${mcqSubjectNames(
                              item.subjectName.toLowerCase()
                            )} text-left col-md-12`}
                          >
                            <icon
                              className={`circle-icon-accordian pos-right-top icon-${mcqSubjectNames(
                                item.subjectName.toLowerCase()
                              )}`}
                            />
                            {item.recentlyPlayedCards[0].map((a, b) => (
                              <div className="chapter-detail-flex">
                                <div className="chapter-detail-flex-item-5 detail-date">
                                  <div className="width-100 text-left detail-value">
                                    <icon className="icon-calendar"></icon>{" "}
                                    {dateFormat(
                                      a.playDate,
                                      "dddd, mmmm dS, yyyy"
                                    )}{" "}
                                  </div>
                                </div>

                                <div className="chapter-detail-flex-item ">
                                  <div className="width-100 text-left detail-label">
                                    Chapter Name:
                                  </div>
                                  <div className="width-100 text-left detail-value">
                                    {" "}
                                    {a.chapterName}{" "}
                                  </div>
                                </div>

                                {a.learningEfficiency ? (
                                  <>
                                    <div className="chapter-detail-flex-item ">
                                      <div className="width-100 text-left  detail-label">
                                        Learning Efficiency:
                                      </div>
                                      <div className="width-100 text-left detail-value">{`${a.learningEfficiency.toFixed(
                                        2
                                      )}%`}</div>
                                    </div>
                                    {/* <span className="pull-right">
                                    Learning Efficiency:&nbsp;
                                    {`${a.learningEfficiency.toFixed(2)}%`}
                                  </span> */}{" "}
                                    <br />{" "}
                                  </>
                                ) : (
                                  <>
                                    <div className="chapter-detail-flex-item ">
                                      <div className="width-100 text-left detail-label">
                                        {" "}
                                        Knowledge Efficiency:{" "}
                                      </div>
                                      <div className="width-100 text-left detail-value">{`${a.knowledgeEfficiency.toFixed(
                                        2
                                      )}%`}</div>
                                    </div>{" "}
                                    <br />{" "}
                                  </>
                                )}
                                {a.topicName ? (
                                  <>
                                    {" "}
                                    <div className="chapter-detail-flex-item ">
                                      <div className="width-100 text-left detail-label">
                                        {" "}
                                        Topic Name:
                                      </div>
                                      <div className="width-100 text-left detail-value">
                                        {a.topicName}{" "}
                                      </div>
                                    </div>
                                    {/* <span className="pull-left">
                                    Topic Name: &nbsp;{a.topicName}{" "}
                                  </span> */}
                                    <br />{" "}
                                  </>
                                ) : (
                                  ""
                                )}
                                {/* <span className="pull-right"> {dateFormat(a.playDate, "dddd, mmmm dS, yyyy, h:MM TT")}</span> <br /> */}
                                {/* <span className="pull-right">
                                {" "}
                                {dateFormat(a.playDate, "dddd, mmmm dS, yyyy")}
                              </span>{" "}
                              <br /> */}
                                {/* <span className=" pull-left">
                                Subject Name: &nbsp;{item.subjectName}{" "}
                              </span>
                              <br /> */}
                              </div>
                            ))}
                          </div>
                        </Panel>
                      </Collapse>
                    ))}
                  </CardBody>
                </Card>
              </Col>
              <Col xs="12" sm="12" lg="6">
                <ConceptWiseProgress
                  // heading="Concepts to Relearn"
                  heading={
                    <div>
                      Concepts to Relearn&nbsp;{" "}
                      <Tooltip title="This section highlights that the total score of the student is less than the global average score of the chapter. Relearn for better understanding.">
                        {" "}
                        <icon
                          className="icon-inform text-icon dash-icon-inform"
                          aria-hidden="true"
                        ></icon>{" "}
                      </Tooltip>{" "}
                    </div>
                  }
                  subjAll={this.state.weakPerformanceComp}
                  items={this.state.weakPerformance}
                />
              </Col>
            </Row>
            <Row>
              <div className="col-md-12">
                <Card className="width-100">
                  <CardHeader className="dash-card-header">
                    Subject Wise Analysis
                  </CardHeader>

                  <CardBody>
                    <Col xs="12" sm="12" lg="12">
                      <div
                        tag="div"
                        className="width-100 d-f-c"
                        blocking={this.state.subjectWiseloader}
                        keepInView
                      >
                        <SubjectWiseProgress
                          items={this.state.subjectWiseProgress}
                          onClick={this.selectSubject}
                          selected_subject={this.state.selectedSubject?.name.toLowerCase()}
                        />
                      </div>
                    </Col>
                  </CardBody>
                </Card>

                {
                  // this.state.selectedSubject &&
                  this.state.loadSubjectData && (
                    <Card className="width-100">
                      <CardBody>
                        <Row>
                          <Col xs="12" sm="12" lg="12">
                            <WealthInfo {...this.state.userWealth} />
                          </Col>
                        </Row>

                        <Row>
                          <Col sm="12" md="12">
                            <ProgressTable
                              isLoading={this.state.isLoading}
                              items={this.state.chapterPerformance}
                              type="chapter"
                              showColumns={["grade", "accuracy"]}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col xs="12" sm="6" lg="6">
                            {/* <ConceptWiseProgress heading="Best Performances" category={'bestperformance'} subjAll={this.state.bestPerformance} items={this.state.bestPerformance} /> */}
                            <ConceptWiseProgress
                              heading={
                                <Tooltip>
                                  Best Performance based on Global Average
                                  &nbsp;
                                  <Tooltip title="It defines the best performance of the student based on the global average scores of all the students.">
                                    {" "}
                                    <icon
                                      className="icon-inform text-icon dash-icon-inform"
                                      aria-hidden="true"
                                    ></icon>{" "}
                                  </Tooltip>
                                </Tooltip>
                              }
                              category={"bestperformance"}
                              subjAll={this.state.bestPerformance}
                              items={this.state.bestPerformance}
                            />
                          </Col>

                          <Col xs="12" sm="6" lg="6">
                            <FastestPerformance
                              items={this.state.fastestPerformance}
                            />
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                  )
                }
              </div>
            </Row>
          </BlockUi>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(StudentDashboard);

// export default StudentDashboard

{
  /* <Row>
 <Col md="2">
 <button aria-pressed="true" className="btn-square btn btn-primary btn-block" onClick={() => this.viewSubjectDetail()}>
 <i className="fa fa-step-backward mt-8" style={{ fontSize: 15, paddingRight: 10 }}></i>
Back to previous page
</button>
 </Col>
 </Row> */
}
